import React from 'react';

const PrinterHeader = () => {
  return (
    <div>

    </div>
  );
};

export default PrinterHeader;
